
import $ from 'jquery';

import {getViewControllerName} from './../general/Util.js';

export class ArticleVariantHandler {

    constructor( containerEl ) {

        this.containerEl = containerEl;
        this.setup();

        // Listen to change of input elements.
        this.containerEl.addEventListener( 'change', ( ev ) => {
            if ( ev.target && ev.target.matches( '.acl_js--color_choice_input' ) ) {
                // Color changed.
                this.reload();
            }

            if ( ev.target && ev.target.matches( '.acl_js--size_choice_input' ) ) {

                const Cookies = window.EN.Cookies;
                Cookies.set( 'lastSelectedSize', ev.target.nextElementSibling.innerText.trim() );

                // Size changed.
                this.reload();
            }
        } );

        // Listen to submit events - legacy way to handle the change event.
        this.containerEl.addEventListener( 'submit', ( ev ) => {
            if ( ev.target && ev.target.closest( '.js-oxWidgetReload' ) ) {
                ev.preventDefault();
                this.reload();
            }
        } );

        this.setInitialSize();
    }

    /**
     * Setup elements inside the container
     * This needs to be called after the reload, because the elements change on reload.
     */
    setup() {
        this.reloadFormEl = this.containerEl.querySelector( '.js-oxWidgetReload' );
        this.variantsEl = this.containerEl.querySelector( '.js-fnSubmit' );

        // Trigger Reload Action for other functionality.
        $( this.containerEl ).trigger( 'article_detail_reload.en' );

        // Replace with native event, so we can use it in DY.
        this.containerEl.dispatchEvent( new CustomEvent( 'finished_change_variant', { bubbles: true } ) );
    }

    getColor() {
        return this.variantsEl.querySelector( '.acl_js--color_choice_input:checked' )?.dataset.selectionId;
    }

    getSize() {
        return this.variantsEl.querySelector( '.acl_js--size_choice_input:checked' )?.value;
    }


    setColor( colorVal ) {

        const colorInputEls = Array.from( this.variantsEl.querySelectorAll( '.acl_js--color_choice_input' ) );
        if ( colorInputEls.length <= 0 ) {
            return;
        }

        // Get current and selected element.
        const selectedEl = colorInputEls.find( ( colorEl ) => {
            return colorEl.dataset.selectionId === colorVal || colorEl.value === colorVal;
        } );

        // Set Button.
        return this.#setValueForInputs( selectedEl, colorInputEls );
    }

    setSize( sizeVal ) {

        const sizeInputEls = Array.from( this.variantsEl.querySelectorAll( '.acl_js--size_choice_input' ) );
        if ( sizeInputEls.length <= 0 ) {
            return;
        }

        // Get current and selected element.
        const selectedEl = sizeInputEls.find( ( sizeEl ) => {
            return sizeEl.value === sizeVal || sizeEl.nextElementSibling.innerText.trim() === sizeVal;
        } );

        // Set Button.
        return this.#setValueForInputs( selectedEl, sizeInputEls );
    }

    #setValueForInputs( selectedEl, inputsEls ) {
        let previousEl = inputsEls.find( ( inputEl ) => inputEl.checked );

        if ( selectedEl ) {
            // Check the selected element.
            inputsEls.forEach( ( inputEl ) => {
                inputEl.checked = inputEl === selectedEl;
            } );
        } else if ( ! previousEl ) {
            // Fallback: If no Element is set, check the first one.
            previousEl = inputsEls[0];
            inputsEls[0].checked = true;
        }

        if ( selectedEl !== previousEl ) {
            return this.reload();
        }

        return Promise.resolve();
    }

    getInitialSize() {

        // Get value from URL.
        const searchParams = new URLSearchParams( window.location.search );
        const paramSize = searchParams.get( 'article-size' );
        if ( paramSize ) {
            return paramSize;
        }

        // Get value from cookie.
        const Cookies = window.EN.Cookies;
        const cookieSize = Cookies?.get( 'lastSelectedSize' );
        if ( cookieSize ) {
            return cookieSize;
        }

        return null;
    }

    setInitialSize() {
        const initialSize = this.getInitialSize();
        if ( initialSize ) {
            this.setSize( initialSize );
        }
    }

    reload( ev ) {

        const action = new URL( this.reloadFormEl.action );
        const method = this.reloadFormEl.method || 'GET';

        // Set Formdata.
        const formDataParams = new URLSearchParams( new FormData( this.reloadFormEl ) );
        formDataParams.set( 'varselid[0]', this.getColor() );
        formDataParams.set( 'varselid[1]', this.getSize() );

        // Convert formdata to GET Params.
        formDataParams.forEach( ( value, key ) => {
            action.searchParams.append( key, value );
        } );

        const options = {
            method,
        };

        // Fetch
        return fetch( action.toString(), options ).then( res => res.text() ).then( response => {
            this.containerEl.innerHTML = response;
            this.setup();
            return response;
        } );
    }
}

export function initArticleVariantHandler( containerEl ) {

    if ( containerEl ) {
        containerEl.ACL_Article_Variant ??= new ArticleVariantHandler( containerEl );
    }
}

$( document ).ready( function() {

    const v_cl = getViewControllerName();

    switch ( v_cl ) {
        case 'details':
            initArticleVariantHandler( document.getElementById( 'details_container' ) );
        break;
    }
});
